import { Core } from '@springtree/eva-services-core';
import buildServiceState from '../../builders/build-service-state.js';
const pingState = buildServiceState({
    allowEmptyRequest: true,
    key: 'ping',
    service: Core.Ping,
    requireEmployee: true,
});
export default pingState;
//# sourceMappingURL=ping-state.js.map